/* Keep marketing widgets out of an active purchase task. No cart/network hooks. */
(function () {
  'use strict';
  if (window.olitansInteractionGuard || !document.body) return;
  window.olitansInteractionGuard = true;

  var body = document.body;
  var openStates = '.open_search, .open_search_mobile, .open_search_desktop, .open_search_menu, .sticky-search-open, .menu_open, .open-mobile-sidebar, .toolbar-modal-open, .cart-sidebar-show, .cart-modal-show, .add-to-cart-show, .quick-view-show, .quickshop-popup-show, .auth-sidebar-show, .show-mobile-options';
  var purchaseInView = false;
  var lastField = null;
  var pending = false;
  var dismissing = false;
  var popupSelector = '.ecomsend__Modal__Container';
  var stickySelector = '.productView-stickyCart, .olitans-sticky-atc';
  var observedSticky = new WeakSet();

  function observeSticky(root) {
    var candidates = Array.from(root.querySelectorAll(stickySelector));
    if (root.matches && root.matches(stickySelector)) candidates.push(root);
    candidates.forEach(function (sticky) {
      if (observedSticky.has(sticky)) return;
      observedSticky.add(sticky);
      new MutationObserver(schedule).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function hasActiveTask() {
    return purchaseInView || body.matches(openStates) || body.classList.contains('template-cart') ||
      !!document.querySelector('.search_details[open], [data-olitans-glass-cart-success].is-visible') ||
      !!document.querySelector('.productView-stickyCart.show-sticky:not(.hidden-sticky), .olitans-sticky-atc.is-visible') ||
      !!(document.activeElement && document.activeElement.matches('input[type="search"]'));
  }
  window.olitansHasActivePurchaseUI = hasActiveTask;

  function sync() {
    pending = false;
    var active = hasActiveTask();
    var hideWidgets = active || purchaseInView;
    if (body.hasAttribute('data-olitans-purchase-ui') !== hideWidgets) {
      body.toggleAttribute('data-olitans-purchase-ui', hideWidgets);
    }

    // Use the app's own close action so its focus trap and scroll lock are also
    // released. Simply hiding an already-open modal can strand the keyboard.
    var popup = active && document.querySelector(popupSelector);
    var close = popup && popup.querySelector('.ecomsend__Modal__CloseButton');
    if (close && !dismissing) {
      dismissing = true;
      close.click();
      requestAnimationFrame(function () {
        dismissing = false;
        if (lastField && lastField.isConnected && lastField.getClientRects().length &&
            getComputedStyle(lastField).visibility === 'visible' &&
            !document.querySelector(popupSelector)) {
          lastField.focus({ preventScroll: true });
        }
      });
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(sync);
  }

  new MutationObserver(schedule).observe(body, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(function (records) {
    var relevant = false;
    records.forEach(function (record) {
      Array.from(record.addedNodes).forEach(function (node) {
        if (node.nodeType !== 1) return;
        var containsSticky = node.matches(stickySelector) || node.querySelector(stickySelector);
        if (containsSticky) observeSticky(node);
        if (containsSticky || node.matches(popupSelector) || node.querySelector(popupSelector)) relevant = true;
      });
    });
    if (relevant) schedule();
  }).observe(body, { childList: true, subtree: true });
  observeSticky(document);
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('focusin', function (event) {
    if (event.target.matches('input[type="search"]')) lastField = event.target;
    else if (!event.target.closest(popupSelector)) lastField = null;
    schedule();
  });
  document.addEventListener('focusout', schedule);
  document.addEventListener('click', schedule);
  document.addEventListener('olitans:cart-success', schedule);
  var success = document.querySelector('[data-olitans-glass-cart-success]');
  if (success) new MutationObserver(schedule).observe(success, { attributes: true, attributeFilter: ['class'] });

  if ('IntersectionObserver' in window) {
    var forms = document.querySelectorAll('.productView-details .productView-form, .productView-details .swatch-custom, .productView-details .product-form__swatch, .productView-details [data-product-information]');
    var visible = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      });
      purchaseInView = visible.size > 0;
      schedule();
    });
    forms.forEach(function (form) { observer.observe(form); });
  }
  sync();
})();
